import { RootState } from '../../store';

export const selectProduct = (state: RootState) => state.products.single.data;
export const selectProductLoading = (state: RootState) => state.products.single.loading;
export const selectProductError = (state: RootState) => state.products.single.error;

export const selectProductsList = (state: RootState) => state.products.list.data;
export const selectProductsListLoading = (state: RootState) => state.products.list.loading;
export const selectProductsListError = (state: RootState) => state.products.list.error;

export const selectCreateProduct = (state: RootState) => state.products.create.data;
export const selectCreateProductLoading = (state: RootState) => state.products.create.loading;
export const selectCreateProductError = (state: RootState) => state.products.create.error;

export const selectUpdateProduct = (state: RootState) => state.products.update.data;
export const selectUpdateProductLoading = (state: RootState) => state.products.update.loading;
export const selectUpdateProductError = (state: RootState) => state.products.update.error;

export const selectDeleteProduct = (state: RootState) => state.products.delete.data;
export const selectDeleteProductLoading = (state: RootState) => state.products.delete.loading;
export const selectDeleteProductError = (state: RootState) => state.products.delete.error;
